import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X, Heart } from "lucide-react";

export const LaunchBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem("jby_launch_banner_dismissed"));

  const dismiss = () => {
    localStorage.setItem("jby_launch_banner_dismissed", "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.6, ease: [0.2, 0.7, 0.3, 1] }}
          className="relative z-20 bg-lapis text-canvas"
          data-testid="launch-offer-banner"
        >
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-2.5 flex items-center justify-center gap-3 text-center">
            <Heart size={13} className="text-peach hidden sm:block shrink-0" fill="currentColor" />
            <p className="text-xs sm:text-[13px] tracking-wide font-medium">
              <span className="uppercase tracking-[0.18em] font-semibold text-peach">Launch week</span>
              <span className="mx-2 opacity-40">·</span>
              The first 20 orders receive a handwritten note from Mehjabin
              <Link
                to="/shop"
                className="ml-3 underline underline-offset-4 decoration-peach/60 hover:decoration-peach font-semibold whitespace-nowrap"
                data-testid="launch-offer-banner-link"
              >
                Visit the shop →
              </Link>
            </p>
            <button
              onClick={dismiss}
              aria-label="Dismiss launch offer"
              className="absolute right-4 md:right-6 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100 transition-opacity"
              data-testid="launch-offer-banner-dismiss"
            >
              <X size={15} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
